export const UPLOAD_USER_STRATEGIES = {
    IMPORT_NEW_ONES: 'import_new_ones',
    UPDATE_EXISTING_ONES: 'update_existing_ones',
};
